let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g3ZhW")).then(() => parcelRequire('dSHkM'));